//auth routes
export const accountLogin = "api/LoginToAccount";
export const userLogout = "api/userLogout/";
// end auth routes

//roles
export const addNewRole = "api/newRole";
export const LoadRoles = "api/roles/";
export const updateRole = "api/roleUpdate";
export const deleteRole = "api/roleDelete/";
//end roles

//end modules
export const newModules = "api/newModule";
export const loadModules = "api/modules";
export const deleteModule = "api/moduleDelete/";
//modules

//permissions
export const newPermissions = "api/newPermission";
export const loadPermissions = "api/permissions";
export const deletePermission = "api/permissionDelete/";
//end permissions

//users
export const newUsers = "api/newUser";
export const loadUsers = "api/users";
export const updateUsers = "api/userUpdate";
export const deleteUser = "api/userDelete/";
export const Userprofile = "api/profileDetails";
export const updateProfile = "api/profileUpdate";
export const updateProfileImg = "api/updateUserImage";
//end users

//user roles
export const userRoles = "api/userRoles/";
export const modulePermissions = "api/modulePermissions";
export const asignuserRoleModules = "api/asignRoleModules";
export const asignModulePermissions = "api/assignModulesPermissions";
//end userroles

//products
export const newProduct = "api/newProduct";
export const loadProducts = "api/products";
export const getProducts = "api/singleproducts";
export const updateProduct = "api/productUpdate";
//end products

//suppliers
export const newSupplier = "api/newSupplier";
export const loadSuppliers = "api/suppliers";
export const supplierUpdate = "api/updateSupplier";
//end suppliers

//consignees
export const newConsignee = "api/newConsignee";
export const loadConsignees = "api/consignees";
export const consigneeUpdate = "api/updateConsignee";
//end consignees

//stock
export const newStock = "api/newstock";
export const loadStocks = "api/stocks";
export const loadStock = "api/stock";
//end stock

//transporters
export const newTransporters = "api/newTransporter";
export const loadTransporters = "api/transporters";
export const updateTransporter = "api/transporterUpdate";
//end transporters

//trucks
export const newTruck = "api/newTruck";
export const loadTrucks = "api/trucks";
export const loadTruck = "api/truck";
export const loadTruckallocation = "api/truckallocations";
export const updateTruck = "api/truckUpdate";
//end trucks

//trips
export const newTrip = "api/newTrip";
export const loadTrips = "api/trips";
//end trips

//consignee payments
export const newPayment = "api/newPayment";
export const loadPayments = "api/payments/";
export const loadTrippayments = "api/trip_payments";
//end consignee payments

//accounttypes
export const newAccount = "api/newAccount";
export const loadAccounttype = "api/accounttypes";
//end accounttypes

//petty cash
export const newPettycash = "api/newCash";
export const loadPettycashes = "api/pettycashes";
export const loadPetty = "api/pettycash";
//end petty cash

//purchase orders
export const newPurchaseorder = "api/newPurchaseorder";
export const loadPurchaseorders = "api/purchaseorders";
export const viewPurchaseorders = "api/purchaseorder";
export const checkPurchaseorders = "api/purchase_order_item";
//end purchase

//goods receiving note
export const newGoodsreceivingnote = "api/newGrn";
export const loadGoodsreceiving = "api/goodsreceiving";
export const loadGoodsnote = "api/goodreceiving";
export const editGoodsnote = "api/good_receiving_item";
export const updateNote = "api/noteUpdate";
//end goods receiing note

//purchases
export const getNote = "api/purchase_receiving_item";
export const newpurchase = "api/newPurchase";
export const loadPurchases = "api/purchases";
export const viewPurchase = "api/purchase";
//end purchases

//sales
export const newSales = "api/newSale";
export const loadSales = "api/sales";
export const viewSale = "api/sale";
//end sales

//expenses
export const newExpense = "api/newExpense";
export const loadExpenses = "api/expenses";
//end expenses

//reports
export const loadTruckSales = "api/trucksales";
export const loadFullSales = "api/fullsales";
export const loadProductSales = "api/productsales";
export const loadFullProductSales = "api/fullproductsales";
export const loadTruckExpenses = "api/truckexpenses";
export const loadFullExpenses = "api/fullexpenses";
export const loadProductPurchases = "api/productpurchases";
export const loadFullPurchases = "api/fullpurchases";
export const loadTruckLabours = "api/trucklabours";
export const loadFullLabours = "api/fulllabours";
export const loadFullLabour = "api/fullnumberlesslabours";
export const loadTruckExpense = "api/truckexpense";
export const loadDiffTyre = "api/difftyres";
export const loadEmployeeAttendances = "api/employeeattendances";
export const loadContainerInterchanges = "api/containerinterchanges";
export const loadTruckInterchanges = "api/truckinterchanges";
export const loadConsigneetrips = "api/consigneetrips";
export const loadTrucktrips = "api/trucktrips";
export const loadTransporterstrips = "api/transporterstrips";
//end reports

//labours
export const newLabour = "api/newLabour";
export const laodLabours = "api/labours";
export const editLabour = "api/labour_items";
export const updateLabour = "api/updateLabour";
//end labours

//labours
export const newNumberlessLabour = "api/newnumberlessLabour";
export const loadNumberlessLabours = "api/numberlesslabours";

//end labours

//oilgrns
export const newOil = "api/newOil";
export const loadOils = "api/oils";
export const loadGrnsnote = "api/oil";
//end oilgrns

//interchanges
export const newInterchange = "api/newInterchange";
export const loadInterchanges = "api/interchanges";
export const updateInterchange = "api/interchangeUpdate";
//end interchanges

//employees
export const addNewEmployee = "api/newEmployee";
export const loadEmployees = "api/employees";
export const updateEmployee = "api/employeeUpdate";
//end employees

//attendances
export const checksIn = "api/checkIn";
export const loadAttendances = "api/attendances";
export const loadAttendance = "api/attendance";
export const checksOut = "api/checkOut";
//end attendances

//invoices
export const newInvoice = "api/newInvoice";
export const loadInvoices = "api/invoices";
//end invoices



// WEBPACK FOOTER //
// ./src/routes/routes.js